import { ref, computed, reactive,unref } from 'vue'
import { defineStore } from 'pinia'
// import { useEmployeeStore } from './employee'
import ss from '../json/ss.json'
import bir from '../json/bir.json'
import pf from '../json/pf.json'

import ph from '../json/ph.json'

import holiday from '../json/holiday.json'

export const useTableStore = defineStore('table', () => {
  // Transact Detail

  const SS = ref([] as any) 
  const BIR = ref([] as any) 
  const PH = ref([] as any) 
  const PF = ref([] as any) 
  const HOLIDAY = ref([] as any) 
  

  const init = async () => {
    SS.value = ss
    BIR.value = bir
    PH.value = ph
    PF.value = pf
    HOLIDAY.value = holiday

    return true
  }


  return {
    init,
    SS,
    BIR,
    PF,
    PH,
    HOLIDAY
  }
})
